<template>
  <div class="playback-request-button h-full" @click="onClick">
    <date-time-setting-icon
      class="playback-request-button-icon"
    ></date-time-setting-icon>
    <span class="playback-request-button-text aisea-text-14-400-black">
      {{ text }}
    </span>
  </div>
</template>

<script>
import DateTimeSettingIcon from "./DateTimeSettingIcon.vue";

export const EMIT_EVENTS = {
  PLAYBACK_REQUEST: "playback-request",
};

export default {
  name: "PlaybackRequestButton",
  props: {
    text: {
      type: String,
      default: "履歴を再生する",
    },
  },
  components: {
    DateTimeSettingIcon,
  },
  methods: {
    onClick(event) {
      this.$emit(EMIT_EVENTS.PLAYBACK_REQUEST, event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.playback-request-button {
  display: flex;
  width: 170px;
  height: 35px;
  padding: 10px;

  justify-content: center;
  align-items: center;
  gap: 12px;

  border-radius: 30px;
  border: 1px solid #4d9ef2;
  background: #fff;

  cursor: pointer;

  &:hover {
    background: #d7effc;
  }

  &:active {
    background: #aee1ff;
  }
  .playback-request-button-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
